var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
		_vm.$s.Segment,
		_vm.$s[("shape_" + (_vm.controlState.shapeInner))],
		_vm.$s[("size_" + (_vm.controlState.sizeInner))],
		( _obj = {}, _obj[_vm.$s.selected] = _vm.isSelected, _obj ) ],on:{"click":_vm.selectSelf}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }